<script lang="ts">
  import CheckBoxIcon from "$lib/icons/CheckBoxIcon.svelte";

  interface Props {
    isCompleted: boolean;
  }

  let { isCompleted }: Props = $props();
</script>

<div class="flex items-center justify-center w-10 h-10 {isCompleted ? 'bg-green-500' : 'bg-gray-500'} rounded-full">
  <CheckBoxIcon/>
</div>

